<template>
  <div class="cf-house-container">
    <!-- ====== 顶部：筛选区域 ====== -->
    <div class="filter-section">
      <el-form :inline="true" size="small" class="filter-form" :model="filterForm">
        <el-form-item label="房屋地址">
          <el-input 
            v-model="filterForm.房屋地址" 
            placeholder="请输入房屋地址" 
            clearable 
            style="width:200px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="合同编号">
          <el-input 
            v-model="filterForm.合同编号" 
            placeholder="请输入合同编号" 
            clearable 
            style="width:150px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="出房人">
          <el-input 
            v-model="filterForm.出房人" 
            placeholder="请输入出房人" 
            clearable 
            style="width:120px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="业务状态">
          <el-select 
            v-model="filterForm.业务状态" 
            placeholder="请选择状态" 
            clearable 
            style="width:140px"
            @change="handleSearch"
          >
            <el-option label="待确认" value="待确认" />
            <el-option label="已出租" value="已出租" />
            <el-option label="已到期" value="已到期" />
            <el-option label="转租中止" value="转租中止" />
            <el-option label="换房中止" value="换房中止" />
            <el-option label="违约中止" value="违约中止" />
            <el-option label="无责中止" value="无责中止" />
            <el-option label="已取消" value="已取消" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>

        <el-form-item label="行政区">
          <el-select 
            v-model="filterForm.行政区" 
            placeholder="请选择行政区" 
            clearable 
            style="width:150px"
            @change="handleSearch"
          >
            <el-option label="青秀区" value="青秀区" />
            <el-option label="兴宁区" value="兴宁区" />
            <el-option label="江南区" value="江南区" />
            <el-option label="良庆区" value="良庆区" />
            <el-option label="邕宁区" value="邕宁区" />
            <el-option label="西乡塘区" value="西乡塘区" />
            <el-option label="武鸣区" value="武鸣区" />
            <el-option label="横州市" value="横州市" />
            <el-option label="宾阳县" value="宾阳县" />
            <el-option label="上林县" value="上林县" />
            <el-option label="马山县" value="马山县" />
            <el-option label="隆安县" value="隆安县" />
          </el-select>
        </el-form-item>

        <el-form-item label="户型">
          <el-select 
            v-model="filterForm.户型" 
            placeholder="请选择户型" 
            clearable 
            style="width:120px"
            @change="handleSearch"
          >
            <el-option label="1室" value="1室" />
            <el-option label="2室" value="2室" />
            <el-option label="3室" value="3室" />
            <el-option label="4室" value="4室" />
            <el-option label="5室" value="5室" />
            <el-option label="6室" value="6室" />
            <el-option label="7室" value="7室" />
          </el-select>
        </el-form-item>

        <el-form-item label="合同起始日">
          <el-date-picker
            v-model="filterForm.合同起始日范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item label="合同到期日">
          <el-date-picker
            v-model="filterForm.合同到期日范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item label="终止时间">
          <el-date-picker
            v-model="filterForm.终止时间范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ====== 中间：按钮区域 ====== -->
    <div class="button-section">
      <el-button 
        type="warning" 
        size="medium" 
        icon="el-icon-document"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleContractExpire"
      >
        合同到期
      </el-button>
      <el-button 
        type="info" 
        size="medium" 
        icon="el-icon-refresh"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleCancelContractExpire"
      >
        取消合同到期
      </el-button>
      <el-button 
        type="danger" 
        size="medium" 
        icon="el-icon-circle-close"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleContractTerminate"
      >
        合同中止
      </el-button>
      <el-button 
        type="info" 
        size="medium" 
        icon="el-icon-refresh-left"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleCancelContractTerminate"
      >
        取消合同中止
      </el-button>
      <el-button 
        type="primary" 
        size="medium" 
        icon="el-icon-edit"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleTerminateInfoModify"
      >
        中止信息修改
      </el-button>
    </div>

    <!-- ====== 下方：表格区域 ====== -->
    <div class="table-section">
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        stripe
        highlight-current-row
        v-loading="loading"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        style="width: 100%"
        max-height="600"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="行政区" label="行政区" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="房屋地址" label="房屋地址" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="户型" label="户型" width="80" align="center" />
        <el-table-column prop="出房租金（元/月）" label="出房租金（元/月）" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row['出房租金（元/月）'] ? `¥${row['出房租金（元/月）']}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="出房押金（元）" label="出房押金（元/月）" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row['出房押金（元）'] ? `¥${row['出房押金（元）']}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="成交差价（元/月）" label="成交差价（元/月）" width="150" align="center">
          <template slot-scope="{ row }">
            {{ row['成交差价（元/月）'] ? `¥${row['成交差价（元/月）']}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="出房费用（元）" label="出房费用（元）" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row['出房费用（元）'] ? `¥${row['出房费用（元）']}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="租金支付周期" label="租金支付周期" width="110" align="center" />
        <el-table-column prop="出房渠道" label="出房渠道" width="100" align="center" />
        <el-table-column prop="空置天数" label="空置天数" width="90" align="center" />
        <el-table-column prop="业务状态" label="业务状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="getBusinessStatusType(row.业务状态)" size="small">
              {{ row.业务状态 || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="中止时间" label="中止时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.中止时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="收房人" label="收房人" width="90" align="center" />
        <el-table-column prop="出房人" label="出房人" width="90" align="center" />
        <el-table-column prop="出房门店" label="出房门店" width="100" align="center" />
        <el-table-column prop="预定时间" label="预定时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.预定时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同起始日" label="合同起始日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同起始日) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同到期日" label="合同到期日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同到期日) }}
          </template>
        </el-table-column>
        <el-table-column prop="租客姓名" label="租客姓名" width="90" align="center" />
        <el-table-column prop="合同编号" label="合同编号" width="130" align="center" show-overflow-tooltip />
        <el-table-column prop="违约收入" label="违约收入" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.违约收入 ? `¥${row.违约收入}` : '-' }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          background
        />
      </div>
    </div>

    <!-- ====== 详情弹窗 ====== -->
    <el-dialog
      title="出房详情"
      :visible.sync="detailDialog.visible"
      width="1000px"
      :close-on-click-modal="false"
      class="detail-dialog"
    >
      <el-tabs v-model="detailActiveTab" type="border-card">
        <!-- 1. 基本信息 -->
        <el-tab-pane label="基本信息" name="base">
          <el-descriptions :column="2" border size="medium">
            <el-descriptions-item label="房屋地址" :span="2">
              {{ detailData.房屋地址 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="租客姓名">
              {{ detailData.租客姓名 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="联系电话">
              {{ detailData.联系电话 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="开户行">
              {{ detailData.开户行 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="银行卡号">
              {{ detailData.银行卡号 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="成交周期（天）">
                {{ detailData['成交周期（天）'] || '-' }}
                </el-descriptions-item>
            <el-descriptions-item label="出房渠道">
              {{ detailData.出房渠道 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="出房人">
              {{ detailData.出房人 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="出房门店">
              {{ detailData.出房门店 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="出房费用（元）">
              {{ detailData['出房费用（元）'] ? `¥${detailData['出房费用（元）']}` : '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="出房押金（元）">
              {{ detailData['出房押金（元）'] ? `¥${detailData['出房押金（元）']}` : '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="合同起始日">
              {{ formatTimestamp(detailData.合同起始日) }}
            </el-descriptions-item>
            <el-descriptions-item label="合同到期日">
              {{ formatTimestamp(detailData.合同到期日) }}
            </el-descriptions-item>

            <el-descriptions-item label="出房租金不含物业/宽带费（元/月）" :span="2">
              {{ detailData['出房租金（元/月）'] ? `¥${detailData['出房租金（元/月）']}` : '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="租金支付周期">
              {{ detailData.租金支付周期 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="定金金额">
              {{ detailData.定金金额 ? `¥${detailData.定金金额}` : '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="物业/宽带费">
              {{ detailData.物业费 ? `¥${detailData.物业费}` : '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="支付周期">
              {{ detailData['物业/宽带费支付周期'] || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="水电气押金">
              {{ detailData.水电气押金 ? `¥${detailData.水电气押金}` : '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="宠物押金">
              {{ detailData.宠物押金 ? `¥${detailData.宠物押金}` : '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="特别约定" :span="2">
              {{ detailData.特别约定 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="是否更换出房人">
              {{ detailData.是否更换出房人 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="是否更换收房人">
              {{ detailData.是否更换收房人 || '-' }}
            </el-descriptions-item>

            <el-descriptions-item label="紧急联系人号码">
              {{ detailData.紧急联系人号码 || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="计算空置天数">
              {{ detailData.计算空置天数 || '-' }}
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>

        <!-- 2. 相关附件 -->
        <el-tab-pane label="相关附件" name="attachment">
          <div class="attachment-section">
            <!-- 身份证信息 -->
            <div class="file-group">
              <div class="file-group-title">身份证信息</div>
              <el-table :data="attachmentData['身份证信息']" border stripe size="small" v-loading="attachmentLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                      <el-image
                        :src="row.show_path_full || row.show_path"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.show_path_full || row.show_path]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="160" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
                    <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!attachmentData['身份证信息'] || attachmentData['身份证信息'].length === 0" class="empty-tip">
                暂无身份证信息文件
              </div>
            </div>

            <!-- 合同信息 -->
            <div class="file-group">
              <div class="file-group-title">合同信息</div>
              <el-table :data="attachmentData['合同信息']" border stripe size="small" v-loading="attachmentLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                      <el-image
                        :src="row.show_path_full || row.show_path"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.show_path_full || row.show_path]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="160" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
                    <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!attachmentData['合同信息'] || attachmentData['合同信息'].length === 0" class="empty-tip">
                暂无合同信息文件
              </div>
            </div>

            <!-- 定金凭证 -->
            <div class="file-group">
              <div class="file-group-title">定金凭证</div>
              <el-table :data="attachmentData['出租预定凭证']" border stripe size="small" v-loading="attachmentLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                      <el-image
                        :src="row.show_path_full || row.show_path"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.show_path_full || row.show_path]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="160" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
                    <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!attachmentData['出租预定凭证'] || attachmentData['出租预定凭证'].length === 0" class="empty-tip">
                暂无定金凭证文件
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 3. 付款计划 -->
        <el-tab-pane label="付款计划" name="payment">
          <div class="payment-section">
            <el-table :data="paymentList" border stripe style="width: 100%" v-loading="paymentLoading">
              <el-table-column prop="payment_date" label="付款时间" width="180" align="center">
                <template slot-scope="{ row }">
                  {{ row.payment_date || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="payment_amount" label="付款金额" width="150" align="center">
                <template slot-scope="{ row }">
                  ¥{{ (row.payment_amount || 0).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="120" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="getPaymentStatusType(row.status)" size="small">
                    {{ getPaymentStatusLabel(row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="第几次付款" label="第几次付款" width="120" align="center" />
            </el-table>
            <div v-if="paymentList.length === 0 && !paymentLoading" class="empty-payment">
              <i class="el-icon-document" />
              <span>暂无付款计划数据</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- ====== 合同中止弹窗 ====== -->
<el-dialog
  title="合同中止"
  :visible.sync="terminateDialog.visible"
  width="600px"
  :close-on-click-modal="false"
  @close="resetTerminateForm"
  class="terminate-dialog"
>
  <el-form :model="terminateForm" :rules="terminateRules" ref="terminateFormRef" label-width="120px" size="small">
    <el-form-item label="房屋地址">
      <el-input v-model="terminateForm.房屋地址" disabled />
    </el-form-item>
    <el-form-item label="中止时间" prop="中止时间" required>
      <el-date-picker
        v-model="terminateForm.中止时间"
        type="date"
        placeholder="请选择中止时间"
        value-format="timestamp"
        style="width:100%"
      />
    </el-form-item>
    <el-form-item label="中止原因" prop="中止原因" required>
      <el-select v-model="terminateForm.中止原因" placeholder="请选择中止原因" style="width:100%">
        <el-option label="无责中止" value="无责中止" />
        <el-option label="转租中止" value="转租中止" />
        <el-option label="换房中止" value="换房中止" />
        <el-option label="违约中止" value="违约中止" />
      </el-select>
    </el-form-item>
    <el-form-item label="违约收入" prop="违约收入">
      <el-input-number
        v-model="terminateForm.违约收入"
        :min="0"
        :precision="2"
        :step="100"
        placeholder="请输入违约收入"
        style="width:100%"
        controls-position="right"
      />
      <div v-if="terminateForm.中止原因 === '违约中止'" style="color: #f56c6c; font-size: 12px; margin-top: 4px;">
        * 违约中止时，违约收入为必填项
      </div>
    </el-form-item>
  </el-form>
  <span slot="footer">
    <el-button @click="terminateDialog.visible = false">取消</el-button>
    <el-button type="primary" @click="handleTerminateConfirm" :loading="terminateDialog.submitting">确认</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'
import { fileMethod } from '@/api/files/fileMethod'
import { sfPlanApi } from '@/api/付款/sfPlanApi'
import { cfPlanApi } from '@/api/付款/cfPlanApi'
export default {
  name: 'CfHouse',

  data() {
    return {
      // ====== 筛选表单 ======
      filterForm: {
        房屋地址: '',
        合同编号: '',
        出房人: '',
        业务状态: '已出租',
        行政区: '',
        户型: '',
        合同起始日范围: [],
        合同到期日范围: [],
        终止时间范围: []
      },

      // ====== 表格数据 ======
      tableData: [],
      loading: false,
      selectedRows: [],

      // ====== 分页 ======
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },

      // ====== 详情弹窗 ======
      detailDialog: {
        visible: false
      },
      detailData: {},
      detailActiveTab: 'base',

      // ====== 附件数据 ======
      attachmentData: {
        '身份证信息': [],
        '合同信息': [],
        '出租预定凭证': []
      },
      attachmentLoading: false,

      // ====== 付款计划 ======
      paymentList: [],
      paymentLoading: false,
      // ====== 合同中止弹窗 ======
    terminateDialog: {
      visible: false,
      submitting: false,
      rowData: null
    },
    terminateForm: {
      房屋地址: '',
      中止时间: null,
      中止原因: '',
      违约收入: null
    },
    terminateRules: {
      中止时间: [
        { required: true, message: '请选择中止时间', trigger: 'change' }
      ],
      中止原因: [
        { required: true, message: '请选择中止原因', trigger: 'change' }
      ]
    }
    }
  },

  computed: {
    canOperate() {
      return this.selectedRows.length === 1
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    // ====== 初始化 ======
    init() {
      this.loadData()
    },

    // ====== 后端字段 -> 前端字段映射 ======
    mapFields(data) {
      if (!data) return {}

      const fieldMap = {
        'id': 'id',
        '行政区': '行政区',
        '房屋地址': '房屋地址',
        '户型': '户型',
        '出房租金（元/月）': '出房租金（元/月）',
        '出房押金（元）': '出房押金（元）',
        '成交差价（元/月）': '成交差价（元/月）',
        '出房费用（元）': '出房费用（元）',
        '租金支付周期': '租金支付周期',
        '出房渠道': '出房渠道',
        '空置天数': '空置天数',
        '业务状态': '业务状态',
        '中止时间': '中止时间',
        '收房人': '收房人',
        '出房人': '出房人',
        '出房门店': '出房门店',
        '预定时间': '预定时间',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '租客姓名': '租客姓名',
        '合同编号': '合同编号',
        '违约收入': '违约收入',
        '联系电话': '联系电话',
        '开户行': '开户行',
        '银行卡号': '银行卡号',
        '成交周期（天）': '成交周期（天）',
        '定金金额': '定金金额',
        '物业费': '物业费',
        '物业/宽带费支付周期': '物业/宽带费支付周期',
        '水电气押金': '水电气押金',
        '宠物押金': '宠物押金',
        '特别约定': '特别约定',
        '是否更换出房人': '是否更换出房人',
        '是否更换收房人': '是否更换收房人',
        '紧急联系人号码': '紧急联系人号码',
        '计算空置天数': '计算空置天数'
      }

      const result = {}
      for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
        if (data.hasOwnProperty(backendKey)) {
          result[frontendKey] = data[backendKey]
        }
      }

      // 时间戳字段转为毫秒级
      const timestampFields = ['合同起始日', '合同到期日', '预定时间', '中止时间']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      return result
    },

    // ====== 加载数据 ======
    loadData() {
      this.loading = true

      const params = {
        tableName: '出房管理',
        conditions: [],
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize
      }

      // 房屋地址 - 模糊匹配
      if (this.filterForm.房屋地址) {
        params.conditions.push({
          field: '房屋地址',
          type: 'STRING',
          operator: 'LIKE',
          value: `%${this.filterForm.房屋地址}%`
        })
      }

      // 合同编号 - 模糊匹配
      if (this.filterForm.合同编号) {
        params.conditions.push({
          field: '合同编号',
          type: 'STRING',
          operator: 'LIKE',
          value: `%${this.filterForm.合同编号}%`
        })
      }

      // 出房人 - 模糊匹配
      if (this.filterForm.出房人) {
        params.conditions.push({
          field: '出房人',
          type: 'STRING',
          operator: 'LIKE',
          value: `%${this.filterForm.出房人}%`
        })
      }

      // 业务状态 - 精确匹配
      if (this.filterForm.业务状态) {
        params.conditions.push({
          field: '业务状态',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.业务状态
        })
      }

      // 行政区 - 精确匹配
      if (this.filterForm.行政区) {
        params.conditions.push({
          field: '行政区',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.行政区
        })
      }

      // 户型 - 精确匹配
      if (this.filterForm.户型) {
        params.conditions.push({
          field: '户型',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.户型
        })
      }

      // 合同起始日范围（毫秒转秒）
      if (this.filterForm.合同起始日范围 && this.filterForm.合同起始日范围.length === 2) {
        const [start, end] = this.filterForm.合同起始日范围
        params.conditions.push({
          field: '合同起始日',
          type: 'TIMESTAMP',
          operator: 'GTE',
          value: Math.floor(start / 1000)
        })
        params.conditions.push({
          field: '合同起始日',
          type: 'TIMESTAMP',
          operator: 'LTE',
          value: Math.floor(end / 1000)
        })
      }

      // 合同到期日范围（毫秒转秒）
      if (this.filterForm.合同到期日范围 && this.filterForm.合同到期日范围.length === 2) {
        const [start, end] = this.filterForm.合同到期日范围
        params.conditions.push({
          field: '合同到期日',
          type: 'TIMESTAMP',
          operator: 'GTE',
          value: Math.floor(start / 1000)
        })
        params.conditions.push({
          field: '合同到期日',
          type: 'TIMESTAMP',
          operator: 'LTE',
          value: Math.floor(end / 1000)
        })
      }

      // 终止时间范围（毫秒转秒）
      if (this.filterForm.终止时间范围 && this.filterForm.终止时间范围.length === 2) {
        const [start, end] = this.filterForm.终止时间范围
        params.conditions.push({
          field: '中止时间',
          type: 'TIMESTAMP',
          operator: 'GTE',
          value: Math.floor(start / 1000)
        })
        params.conditions.push({
          field: '中止时间',
          type: 'TIMESTAMP',
          operator: 'LTE',
          value: Math.floor(end / 1000)
        })
      }

      // 默认按创建时间倒序
      params.conditions.push({
        field: 'create_time',
        type: 'TIMESTAMP',
        operator: 'ORDER_BY_DESC'
      })

      console.log('请求参数===', params)

      sqlBaseApi.query(params).then((res) => {
        console.log('返回数据===', res)

        if (res.code === 200) {
          const rawList = res.data.list || []
          this.tableData = rawList.map(item => this.mapFields(item))
          this.pageInfo.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        console.error('请求失败===', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // ====== 搜索 ======
    handleSearch() {
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    // ====== 重置搜索 ======
    resetSearch() {
      this.filterForm = {
        房屋地址: '',
        合同编号: '',
        出房人: '',
        业务状态: '已出租',
        行政区: '',
        户型: '',
        合同起始日范围: [],
        合同到期日范围: [],
        终止时间范围: []
      }
      this.handleSearch()
    },

    // ====== 分页 ======
    handleSizeChange(size) {
      this.pageInfo.pageSize = size
      this.loadData()
    },

    handleCurrentChange(page) {
      this.pageInfo.pageIndex = page
      this.loadData()
    },

    // ====== 表格选择变化 ======
    handleSelectionChange(selection) {
      console.log('选中行数:', selection.length)
      this.selectedRows = selection
    },

    // ====== 行点击 ======
    handleRowClick(row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },

    // ====== 双击行 - 打开详情 ======
    handleRowDblclick(row) {
      this.detailData = { ...row }
      this.detailActiveTab = 'base'
      this.detailDialog.visible = true
      if (row.id) {
        this.loadAttachmentData(row.id)
        this.loadPaymentData(row.id)
      }
    },

    // ====== 详情 ======
    handleDetail() {
      if (this.selectedRows.length === 0) return
      this.detailData = { ...this.selectedRows[0] }
      this.detailActiveTab = 'base'
      this.detailDialog.visible = true
      if (this.selectedRows[0].id) {
        this.loadAttachmentData(this.selectedRows[0].id)
        this.loadPaymentData(this.selectedRows[0].id)
      }
    },

    // ====== 业务状态标签颜色 ======
    getBusinessStatusType(status) {
      const map = {
        '待确认': 'info',
        '已出租': 'success',
        '已到期': 'warning',
        '转租中止': 'danger',
        '换房中止': 'danger',
        '违约中止': 'danger',
        '无责中止': 'info',
        '已取消': 'info',
        '其他': 'info'
      }
      return map[status] || 'info'
    },

    // ====== 付款状态映射 ======
    getPaymentStatusType(status) {
      const map = {
        'pending': 'danger',
        'paid': 'success',
        'partial': 'warning',
        'terminated': 'info',
        'other': 'info'
      }
      return map[status] || 'info'
    },

    getPaymentStatusLabel(status) {
      const map = {
        'pending': '待付',
        'paid': '已付',
        'partial': '部分付款',
        'terminated': '已中止',
        'other': '其他'
      }
      return map[status] || status
    },

    // ====== 时间戳格式化 ======
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ====== 刷新数据 ======
    refresh() {
      this.loadData()
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 加载附件数据 ======
    async loadAttachmentData(fatherId) {
      if (!fatherId) return

      this.attachmentLoading = true
      const type1List = ['身份证信息', '合同信息', '出租预定凭证']
      const fileBaseUrl = window.location.origin + '/nngy'

      try {
        const promises = type1List.map(type1 => {
          return fileMethod.listFiles('出房管理', String(fatherId), type1, null)
            .then(res => {
              if (res.code === 200) {
                let data = res.data?.list || []
                data = data.map(item => {
                  if (item.show_path) {
                    const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
                    item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + item.show_path
                  } else {
                    item.show_path_full = ''
                  }
                  return item
                })
                return { type1, data }
              }
              return { type1, data: [] }
            })
            .catch(() => ({ type1, data: [] }))
        })

        const results = await Promise.all(promises)
        results.forEach(({ type1, data }) => {
          this.attachmentData[type1] = data
        })
      } catch (error) {
        console.error('加载附件失败:', error)
      } finally {
        this.attachmentLoading = false
      }
    },

    // ====== 查看文件 ======
    handleFileView(row) {
      if (row.show_path_full || row.show_path) {
        const url = row.show_path_full || row.show_path
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 下载文件 ======
    async handleFileDownload(row) {
      if (!row.show_path) {
        this.$message.warning('文件路径不存在')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '正在下载文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const res = await fileMethod.downloadFile(row.show_path)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = row.show_name || '下载文件'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请重试')
      } finally {
        loading.close()
      }
    },

    // ====== 加载付款计划 ======
    async loadPaymentData(fatherId) {
      if (!fatherId) return

      this.paymentLoading = true

      try {
        const params = {
          房源ID: String(fatherId)
        }

        const res = await sfPlanApi.select(params)

        if (res.code === 200) {
          const list = res.data?.list || []
          this.paymentList = list.map(item => ({
            payment_date: this.formatTimestamp(item.付款日期),
            payment_amount: item.付款金额 || 0,
            status: this.mapPaymentStatus(item.状态),
            '第几次付款': item.第几次付款 || '-'
          }))
        } else {
          this.paymentList = []
        }
      } catch (error) {
        console.error('加载付款计划失败:', error)
        this.paymentList = []
      } finally {
        this.paymentLoading = false
      }
    },

    mapPaymentStatus(status) {
      const map = {
        '待付': 'pending',
        '部分付款': 'partial',
        '已完成': 'paid',
        '已中止': 'terminated',
        '已作废': 'other',
        '其他': 'other'
      }
      return map[status] || 'other'
    },

    // ====== 按钮功能（预留空函数） ======

   // ====== 合同到期 ======
handleContractExpire() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  this.$confirm(
    `是否要合同到期？点击后接下来的付款状态均显示到期。`,
    '合同到期确认',
    {
      type: 'warning',
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    }
  ).then(async () => {
    try {
      // 1. 批量修改出房付款计划状态：待收、部分收款 → 已到期
      const statusRes = await cfPlanApi.batchUpdateStatus({
        出房ID: String(row.id),
        当前状态: '待收',
        目标状态: '已到期'
      })
      console.log('批量修改状态(待收→已到期)返回:', statusRes)
      if (statusRes.code !== 200) {
        this.$message.error(`批量修改付款计划状态(待收→已到期)失败: ${statusRes.message}`)
        return
      }

      // 再处理部分收款 → 已到期
      const statusRes2 = await cfPlanApi.batchUpdateStatus({
        出房ID: String(row.id),
        当前状态: '部分收款',
        目标状态: '已到期'
      })
      console.log('批量修改状态(部分收款→已到期)返回:', statusRes2)
      if (statusRes2.code !== 200) {
        this.$message.error(`批量修改付款计划状态(部分收款→已到期)失败: ${statusRes2.message}`)
        return
      }

      // 2. 更新出房管理状态为"已到期"
      const cfRes = await sqlBaseApi.update({
        tableName: '出房管理',
        data: {
          业务状态: '已到期'
        },
        where: {
          id: row.id
        }
      })
      console.log('更新出房管理返回:', cfRes)
      if (cfRes.code !== 200) {
        this.$message.error(`更新出房管理失败: ${cfRes.message}`)
        return
      }

      // 3. 更新房源表状态为"待出租"
      if (row.房源ID) {
        const houseRes = await sqlBaseApi.update({
          tableName: '房源',
          data: {
            业务状态: '待出租'
          },
          where: {
            id: row.房源ID
          }
        })
        console.log('更新房源表返回:', houseRes)
        if (houseRes.code !== 200) {
          this.$message.error(`更新房源表失败: ${houseRes.message}`)
          return
        }
      }

      this.$message.success('合同到期处理成功！')
      this.loadData()
      if (this.detailDialog.visible) {
        this.detailDialog.visible = false
      }
    } catch (error) {
      console.error('合同到期失败:', error)
      this.$message.error(error.message || '合同到期失败，请稍后重试')
    }
  }).catch(() => {
    this.$message.info('已取消操作')
  })
},

// ====== 取消合同到期 ======
handleCancelContractExpire() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  this.$confirm(
    `是否取消合同到期？点击后此房源继续给租客出租。`,
    '取消合同到期确认',
    {
      type: 'warning',
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    }
  ).then(async () => {
    try {
      // 需要先查询出房付款计划中状态为"已到期"的记录，根据已收字段分组
      const selectRes = await cfPlanApi.selectPlan({
        出房ID: String(row.id),
        状态: ['已到期']
      })
      console.log('查询已到期记录返回:', selectRes)

      if (selectRes.code === 200) {
        const list = selectRes.data?.list || []
        // 分组：已收 == 0 和 已收 != 0
        const zeroList = list.filter(item => item.已收 === 0 || item.已收 === null || item.已收 === undefined)
        const nonZeroList = list.filter(item => item.已收 !== 0 && item.已收 !== null && item.已收 !== undefined)

        // 已收 == 0 → 改为"待收"
        if (zeroList.length > 0) {
          const res = await cfPlanApi.batchUpdateStatus({
            出房ID: String(row.id),
            当前状态: '已到期',
            目标状态: '待收'
          })
          console.log('批量修改状态(已到期→待收)返回:', res)
          if (res.code !== 200) {
            this.$message.error(`批量修改付款计划状态(已到期→待收)失败: ${res.message}`)
            return
          }
        }

        // 已收 != 0 → 改为"部分收款"
        if (nonZeroList.length > 0) {
          const res = await cfPlanApi.batchUpdateStatus({
            出房ID: String(row.id),
            当前状态: '已到期',
            目标状态: '部分收款'
          })
          console.log('批量修改状态(已到期→部分收款)返回:', res)
          if (res.code !== 200) {
            this.$message.error(`批量修改付款计划状态(已到期→部分收款)失败: ${res.message}`)
            return
          }
        }
      }

      // 2. 更新出房管理状态为"已出租"
      const cfRes = await sqlBaseApi.update({
        tableName: '出房管理',
        data: {
          业务状态: '已出租'
        },
        where: {
          id: row.id
        }
      })
      console.log('更新出房管理返回:', cfRes)
      if (cfRes.code !== 200) {
        this.$message.error(`更新出房管理失败: ${cfRes.message}`)
        return
      }

      // 3. 更新房源表状态为"已出租"
      if (row.房源ID) {
        const houseRes = await sqlBaseApi.update({
          tableName: '房源',
          data: {
            业务状态: '已出租'
          },
          where: {
            id: row.房源ID
          }
        })
        console.log('更新房源表返回:', houseRes)
        if (houseRes.code !== 200) {
          this.$message.error(`更新房源表失败: ${houseRes.message}`)
          return
        }
      }

      this.$message.success('取消合同到期成功！')
      this.loadData()
      if (this.detailDialog.visible) {
        this.detailDialog.visible = false
      }
    } catch (error) {
      console.error('取消合同到期失败:', error)
      this.$message.error(error.message || '取消合同到期失败，请稍后重试')
    }
  }).catch(() => {
    this.$message.info('已取消操作')
  })
},

// ====== 打开合同中止弹窗 ======
handleContractTerminate() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  // 检查业务状态是否已经是中止状态
  const terminateStatuses = ['无责中止', '转租中止', '换房中止', '违约中止']
  if (terminateStatuses.includes(row.业务状态)) {
    this.$message.warning('该记录已经是中止状态，请使用"中止信息修改"功能')
    return
  }

  this.terminateDialog.rowData = row
  this.terminateForm = {
    房屋地址: row.房屋地址 || '',
    中止时间: null,
    中止原因: '',
    违约收入: null
  }
  this.terminateDialog.visible = true
  this.$nextTick(() => {
    if (this.$refs.terminateFormRef) {
      this.$refs.terminateFormRef.clearValidate()
    }
  })
},

// ====== 合同中止弹窗提交 ======
handleTerminateConfirm() {
  this.$refs.terminateFormRef.validate((valid) => {
    if (!valid) {
      this.$message.warning('请完善表单信息')
      return
    }

    // 违约中止时，违约收入必填
    if (this.terminateForm.中止原因 === '违约中止' && (this.terminateForm.违约收入 === null || this.terminateForm.违约收入 === undefined)) {
      this.$message.warning('违约中止时，违约收入为必填项')
      return
    }

    const row = this.terminateDialog.rowData

    this.$confirm(
      `确认中止合同（房屋地址：${row.房屋地址}）吗？`,
      '合同中止确认',
      {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }
    ).then(async () => {
      this.terminateDialog.submitting = true

      try {
        // 1. 批量修改出房付款计划状态：待收、部分收款 → 已中止
        const statusRes = await cfPlanApi.batchUpdateStatus({
          出房ID: String(row.id),
          当前状态: '待收',
          目标状态: '已中止'
        })
        console.log('批量修改状态(待收→已中止)返回:', statusRes)
        if (statusRes.code !== 200) {
          this.$message.error(`批量修改付款计划状态(待收→已中止)失败: ${statusRes.message}`)
          this.terminateDialog.submitting = false
          return
        }

        const statusRes2 = await cfPlanApi.batchUpdateStatus({
          出房ID: String(row.id),
          当前状态: '部分收款',
          目标状态: '已中止'
        })
        console.log('批量修改状态(部分收款→已中止)返回:', statusRes2)
        if (statusRes2.code !== 200) {
          this.$message.error(`批量修改付款计划状态(部分收款→已中止)失败: ${statusRes2.message}`)
          this.terminateDialog.submitting = false
          return
        }

        // 2. 更新出房管理
        const updateData = {
          业务状态: this.terminateForm.中止原因,
          中止时间: Math.floor(this.terminateForm.中止时间 / 1000)
        }
        if (this.terminateForm.违约收入 !== null && this.terminateForm.违约收入 !== undefined) {
          updateData.违约收入 = this.terminateForm.违约收入
        }

        const cfRes = await sqlBaseApi.update({
          tableName: '出房管理',
          data: updateData,
          where: {
            id: row.id
          }
        })
        console.log('更新出房管理返回:', cfRes)
        if (cfRes.code !== 200) {
          this.$message.error(`更新出房管理失败: ${cfRes.message}`)
          this.terminateDialog.submitting = false
          return
        }

        // 3. 更新房源表状态为"待出租"
        if (row.房源ID) {
          const houseRes = await sqlBaseApi.update({
            tableName: '房源',
            data: {
              业务状态: '待出租'
            },
            where: {
              id: row.房源ID
            }
          })
          console.log('更新房源表返回:', houseRes)
          if (houseRes.code !== 200) {
            this.$message.error(`更新房源表失败: ${houseRes.message}`)
            this.terminateDialog.submitting = false
            return
          }
        }

        this.$message.success('合同中止成功！')
        this.terminateDialog.visible = false
        this.loadData()
        if (this.detailDialog.visible) {
          this.detailDialog.visible = false
        }
      } catch (error) {
        console.error('合同中止失败:', error)
        this.$message.error(error.message || '合同中止失败，请稍后重试')
      } finally {
        this.terminateDialog.submitting = false
      }
    }).catch(() => {
      this.$message.info('已取消操作')
    })
  })
},

// ====== 重置合同中止表单 ======
resetTerminateForm() {
  this.terminateForm = {
    房屋地址: '',
    中止时间: null,
    中止原因: '',
    违约收入: null
  }
  this.terminateDialog.submitting = false
  this.terminateDialog.rowData = null
  this.terminateDialog.isModifyMode = false
  this.$nextTick(() => {
    if (this.$refs.terminateFormRef) {
      this.$refs.terminateFormRef.clearValidate()
    }
  })
},

// ====== 取消合同中止 ======
handleCancelContractTerminate() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  // 检查是否是中止状态
  const terminateStatuses = ['无责中止', '转租中止', '换房中止', '违约中止']
  if (!terminateStatuses.includes(row.业务状态)) {
    this.$message.warning('该记录不是中止状态，无法取消合同中止')
    return
  }

  this.$confirm(
    `是否取消合同中止？点击后此房源继续给租客出租。`,
    '取消合同中止确认',
    {
      type: 'warning',
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    }
  ).then(async () => {
    try {
      // 查询出房付款计划中状态为"已中止"的记录，根据已收字段分组
      const selectRes = await cfPlanApi.selectPlan({
        出房ID: String(row.id),
        状态: ['已中止']
      })
      console.log('查询已中止记录返回:', selectRes)

      if (selectRes.code === 200) {
        const list = selectRes.data?.list || []
        const zeroList = list.filter(item => item.已收 === 0 || item.已收 === null || item.已收 === undefined)
        const nonZeroList = list.filter(item => item.已收 !== 0 && item.已收 !== null && item.已收 !== undefined)

        if (zeroList.length > 0) {
          const res = await cfPlanApi.batchUpdateStatus({
            出房ID: String(row.id),
            当前状态: '已中止',
            目标状态: '待收'
          })
          console.log('批量修改状态(已中止→待收)返回:', res)
          if (res.code !== 200) {
            this.$message.error(`批量修改付款计划状态(已中止→待收)失败: ${res.message}`)
            return
          }
        }

        if (nonZeroList.length > 0) {
          const res = await cfPlanApi.batchUpdateStatus({
            出房ID: String(row.id),
            当前状态: '已中止',
            目标状态: '部分收款'
          })
          console.log('批量修改状态(已中止→部分收款)返回:', res)
          if (res.code !== 200) {
            this.$message.error(`批量修改付款计划状态(已中止→部分收款)失败: ${res.message}`)
            return
          }
        }
      }

      // 2. 更新出房管理状态为"已出租"，清空中止时间、违约收入
      const cfRes = await sqlBaseApi.update({
        tableName: '出房管理',
        data: {
          业务状态: '已出租',
          中止时间: null,
          违约收入: null
        },
        where: {
          id: row.id
        }
      })
      console.log('更新出房管理返回:', cfRes)
      if (cfRes.code !== 200) {
        this.$message.error(`更新出房管理失败: ${cfRes.message}`)
        return
      }

      // 3. 更新房源表状态为"已出租"
      if (row.房源ID) {
        const houseRes = await sqlBaseApi.update({
          tableName: '房源',
          data: {
            业务状态: '已出租'
          },
          where: {
            id: row.房源ID
          }
        })
        console.log('更新房源表返回:', houseRes)
        if (houseRes.code !== 200) {
          this.$message.error(`更新房源表失败: ${houseRes.message}`)
          return
        }
      }

      this.$message.success('取消合同中止成功！')
      this.loadData()
      if (this.detailDialog.visible) {
        this.detailDialog.visible = false
      }
    } catch (error) {
      console.error('取消合同中止失败:', error)
      this.$message.error(error.message || '取消合同中止失败，请稍后重试')
    }
  }).catch(() => {
    this.$message.info('已取消操作')
  })
},

// ====== 中止信息修改 ======
handleTerminateInfoModify() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  // 前置验证：必须是中止状态
  const terminateStatuses = ['无责中止', '转租中止', '换房中止', '违约中止']
  if (!terminateStatuses.includes(row.业务状态)) {
    this.$message.warning(`此记录并非中止状态（目前是${row.业务状态 || '未知'}状态），不可修改`)
    return
  }

  // 复用合同中止弹窗
  this.terminateDialog.rowData = row
  this.terminateForm = {
    房屋地址: row.房屋地址 || '',
    中止时间: row.中止时间 || null,
    中止原因: row.业务状态 || '',
    违约收入: row.违约收入 !== undefined && row.违约收入 !== null ? row.违约收入 : null
  }
  this.terminateDialog.visible = true
  this.terminateDialog.isModifyMode = true
  this.$nextTick(() => {
    if (this.$refs.terminateFormRef) {
      this.$refs.terminateFormRef.clearValidate()
    }
  })
},

// ====== 修改"合同中止弹窗提交"方法，支持两种模式 ======
// 将原来的 handleTerminateConfirm 改为：
handleTerminateConfirm() {
  this.$refs.terminateFormRef.validate((valid) => {
    if (!valid) {
      this.$message.warning('请完善表单信息')
      return
    }

    if (this.terminateForm.中止原因 === '违约中止' && (this.terminateForm.违约收入 === null || this.terminateForm.违约收入 === undefined)) {
      this.$message.warning('违约中止时，违约收入为必填项')
      return
    }

    const row = this.terminateDialog.rowData
    const isModifyMode = this.terminateDialog.isModifyMode || false

    const confirmMsg = isModifyMode
      ? `确认修改中止信息（房屋地址：${row.房屋地址}）吗？`
      : `确认中止合同（房屋地址：${row.房屋地址}）吗？`

    this.$confirm(
      confirmMsg,
      isModifyMode ? '中止信息修改确认' : '合同中止确认',
      {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }
    ).then(async () => {
      this.terminateDialog.submitting = true

      try {
        const updateData = {
          业务状态: this.terminateForm.中止原因,
          中止时间: Math.floor(this.terminateForm.中止时间 / 1000)
        }
        if (this.terminateForm.违约收入 !== null && this.terminateForm.违约收入 !== undefined) {
          updateData.违约收入 = this.terminateForm.违约收入
        }

        // 更新出房管理
        const cfRes = await sqlBaseApi.update({
          tableName: '出房管理',
          data: updateData,
          where: {
            id: row.id
          }
        })
        console.log('更新出房管理返回:', cfRes)
        if (cfRes.code !== 200) {
          this.$message.error(`更新出房管理失败: ${cfRes.message}`)
          this.terminateDialog.submitting = false
          return
        }

        // 如果是中止信息修改模式（只更新出房管理），直接完成
        if (isModifyMode) {
          this.$message.success('中止信息修改成功！')
          this.terminateDialog.visible = false
          this.loadData()
          if (this.detailDialog.visible) {
            this.detailDialog.visible = false
          }
          this.terminateDialog.submitting = false
          return
        }

        // 以下是合同中止模式：还需要更新付款计划和房源表
        // 1. 批量修改出房付款计划状态
        const statusRes = await cfPlanApi.batchUpdateStatus({
          出房ID: String(row.id),
          当前状态: '待收',
          目标状态: '已中止'
        })
        if (statusRes.code !== 200) {
          this.$message.error(`批量修改付款计划状态(待收→已中止)失败: ${statusRes.message}`)
          this.terminateDialog.submitting = false
          return
        }

        const statusRes2 = await cfPlanApi.batchUpdateStatus({
          出房ID: String(row.id),
          当前状态: '部分收款',
          目标状态: '已中止'
        })
        if (statusRes2.code !== 200) {
          this.$message.error(`批量修改付款计划状态(部分收款→已中止)失败: ${statusRes2.message}`)
          this.terminateDialog.submitting = false
          return
        }

        // 3. 更新房源表
        if (row.房源ID) {
          const houseRes = await sqlBaseApi.update({
            tableName: '房源',
            data: {
              业务状态: '待出租'
            },
            where: {
              id: row.房源ID
            }
          })
          if (houseRes.code !== 200) {
            this.$message.error(`更新房源表失败: ${houseRes.message}`)
            this.terminateDialog.submitting = false
            return
          }
        }

        this.$message.success('合同中止成功！')
        this.terminateDialog.visible = false
        this.loadData()
        if (this.detailDialog.visible) {
          this.detailDialog.visible = false
        }
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error(error.message || '操作失败，请稍后重试')
      } finally {
        this.terminateDialog.submitting = false
      }
    }).catch(() => {
      this.$message.info('已取消操作')
    })
  })
}
  }
}
</script>

<style scoped>
.cf-house-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;
}

.filter-section {
  background: #fff;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.filter-form {
  margin-bottom: 0;
}

.button-section {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.button-section .el-button {
  margin-bottom: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
}

.detail-dialog .el-tabs {
  margin-top: 0;
}

.detail-dialog .el-tabs__content {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.file-group {
  margin-bottom: 24px;
}

.file-group:last-child {
  margin-bottom: 0;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding: 8px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

.payment-section {
  padding: 10px 0;
}

.empty-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #909399;
}

.empty-payment i {
  font-size: 48px;
  margin-bottom: 12px;
  color: #c0c4cc;
}

.empty-payment span {
  font-size: 14px;
}

@media (max-width: 768px) {
  .cf-house-container {
    padding: 10px;
  }

  .filter-form .el-form-item {
    display: block;
    margin-right: 0;
  }

  .button-section .el-button {
    margin-bottom: 8px;
  }
}
</style>